import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontLeftDoorInteriorProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function FrontLeftDoorInterior(props: FrontLeftDoorInteriorProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Front Left Door"
      width={310}
      height={95}
      viewBox="0 0 310 95"
      position={{bottom: -28, left: 409}}
    >
      <path
        d="M304.904 47.6953C308.902 40.7671 309.236 34.8086 308.902 32.6953L282.911 33C231.927 33 140.015 34.5106 82.0163 33.958L32.9899 32C29.9908 33 27.6937 33.435 25.9921 34C6.18142 40.5778 1 59.0248 1 66H295.906C297.239 62.8867 300.905 54.6235 304.904 47.6953Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M8.99747 46.4783C86.5768 45.962 194.928 45.6405 306.903 44.3913L8.99747 46.4783Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M32.9899 32C57.9819 36 211.074 33 282.911 33H308.902C309.236 35.1132 308.902 40.7671 304.904 47.6953C300.905 54.6235 297.239 62.8868 295.906 66L1 65.9996C1 59.0244 6.18142 40.5778 25.9921 34C27.6937 33.435 29.9908 33 32.9899 32Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M32.9898 32C40.342 33.1767 58.78 33.7803 82.974 34L82.1891 34.7949C80.3108 36.7419 78.2437 39.3527 79.9544 41.9668C86.4033 40.9884 93.1575 40.7034 97.2068 41.3389C103.637 42.3479 111.273 90.1431 108.306 92.1611C105.338 94.1791 95.2277 97.8409 79.4009 81.6982C74.0047 76.1943 69.8339 70.7988 67.0454 65.876L66.9791 66C65.1591 62.7047 59.9813 53.6 55.9825 48C51.9838 42.4 38.9879 35 32.9898 32Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M79.4009 81.6978C95.2283 97.8412 105.338 94.1789 108.306 92.1609C111.274 90.1429 103.637 42.3483 97.2067 41.3392C90.7768 40.3302 77.5269 41.6401 69.5088 44.3661C57.6382 48.402 62.5552 64.5157 79.4009 81.6978Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M90.9715 41C95.9699 46 103.967 75 103.967 93"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M66.9791 66C65.1591 62.7047 59.9813 53.6 55.9825 48C51.9838 42.4 38.9879 35 32.9898 32C40.342 33.1767 58.78 33.7803 82.974 34C80.9746 36 77.9756 39 79.9749 42"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M244.923 56C259.855 56.0003 279.764 58 277.773 61C271.033 71.1562 252.886 71 244.923 71C236.959 71 218.812 71.1562 212.072 61C210.081 58 229.99 56.0003 244.923 56ZM227.928 62C229.693 64.2432 232.418 66 236.925 66H252.92C257.428 66 260.152 64.2432 261.917 62H227.928Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M277.774 61C271.033 71.1563 252.886 70.9999 244.923 70.9999C236.959 70.9999 218.812 71.1563 212.071 61C210.08 58 229.99 56.0003 244.923 56C259.855 56.0003 279.765 58 277.774 61Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M263.917 57C263.583 59.6667 260.917 66 252.92 66C244.923 66 244.923 66 244.923 66C244.923 66 244.923 66 236.925 66C228.928 66 226.262 59.6667 225.929 57"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M227.928 62H261.917"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M175 1C183.23 1 189.117 3.09208 193 6.16699V6H255C259.995 6 284.948 6 284.999 17.9629H309V32.9229H282.91C211.074 32.9229 57.9836 35.915 32.9902 31.9258H33C22.2442 29.953 17.2645 23.7808 16 20.9551V20.8076C26.6449 18.1571 44 13.4678 44 4C44 13.9734 52 17.9629 66 17.9629H73V16.9434C73 1.00009 76 1 85 1H175Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M66 17.9628L309 17.9628V32.9229H282.911C211.074 32.9229 57.9819 35.9149 32.9898 31.9255L33 31.9255C22.2439 29.9527 17.2643 23.7805 16 20.9548V20.8072C26.6449 18.1567 44 13.4678 44 4.00001C44 13.9734 52 17.9628 66 17.9628Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M73 18C73 2.05673 76 1 85 1H175C192 1 199 9.92766 199 18"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M193 6H255C260 6 285 6 285 18"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <rect
        width="7"
        height="7"
        rx="3.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 102 12.9999)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        width="3"
        height="8"
        rx="1.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 91 8)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        width="3"
        height="8"
        rx="1.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 91 14)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        width="3"
        height="8"
        rx="1.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 114 8)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        width="3"
        height="8"
        rx="1.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 114 14)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        width="7"
        height="7"
        rx="3.5"
        transform="matrix(1 0 0 -1 268 29)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
